// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from "react";
import BreadcrumbGroup from "@amzn/awsui-components-react/polaris/breadcrumb-group";

const resourcesBreadcrumbs = [
  {
    text: "Devices ASIN Central",
    href: "/",
  },
  {
    text: "Stamper Tool",
    href: "/stamper",
  },
];

export function Breadcrumbs() {
  return (
    <BreadcrumbGroup
      items={resourcesBreadcrumbs}
      expandAriaLabel="Show path"
      ariaLabel="Breadcrumbs"
    />
  );
}
